const HOME_TAB = 'item-editor';

const ALWAYS_AVAILABLE_TABS = new Set([
    HOME_TAB,
    'item-history',
    'item-grouping',
    'item-details',
]);

const PUBLICATION_STATUS_TAB = 'item-publication-status';

/**
 * Keeps the current editor sidebar tab across next/prev when the new item
 * can still show it; otherwise falls back to Home.
 *
 * Callers must pass a loaded item. While the next item is still loading,
 * keep the previous tab in React state instead of calling this helper.
 */
const resolveStickyEditorTab = (
    currentTab: string,
    item: { published__?: unknown },
    hierarchies: string[] = [],
): string => {
    if (ALWAYS_AVAILABLE_TABS.has(currentTab)) {
        return currentTab;
    }

    if (currentTab === PUBLICATION_STATUS_TAB) {
        return item.published__ ? currentTab : HOME_TAB;
    }

    return hierarchies.includes(currentTab) ? currentTab : HOME_TAB;
};

export { HOME_TAB, resolveStickyEditorTab };
